import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getUrlParameter } from '../../../../global/data/url.js'
import updateViewAllHoldingsLink from '../../Helpers/UpdateViewAllHoldingsLink.js'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'
import Tooltip from '../../../Tooltip/Tooltip.jsx'
import {
  getETFTooltipContent,
  getTooltipContentByKey,
  getEtfHoldingsDisclousreData,
} from '../../../Tooltip/tooltipUtil.js'
import DOMPurify from 'dompurify'

class PortfolioTopHoldingsETF extends Component {
  state = {
    disclosure: '',
  }

  componentDidMount() {
    updateViewAllHoldingsLink()

    this.getEtfHoldingsDisclousre()
  }

  renderTopHoldingsTable() {
    const { etfHoldings } = this.props.etfHoldingDetail

    return etfHoldings.map((holding, index) => {
      if (index < 10) {
        return (
          <tr className="Table-row" key={holding.description + index}>
            <td className="Table-cell">
              <div>{holding.description}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.displaySymbol}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.assetType}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.quantity}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.weightPercentage}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.marketValue}</div>
            </td>
            <td className="Table-cell u-textRight">
              <div>{holding.notionalValue}</div>
            </td>
          </tr>
        )
      }
    })
  }

  async getEtfHoldingsDisclousre() {
    const disclosure = await getEtfHoldingsDisclousreData()
    this.setState({
      disclosure,
    })
  }

  render() {
    const etfTooltipData = getETFTooltipContent()

    const { nsccFileUrl } = this.props.fund
    const { etfHoldingAsOfDate } = this.props.etfHoldingDetail
    const cusip = getUrlParameter('cusip')
    const downloadFullHoldings =
      '/cmg.svc/exportETFholdings?fundGroupName=ETF&fileType=csv&cusip=' + cusip

    return (
      <div id="ampf-trace-loaded-section-portfolio-details-top-holdings">
        <div id="top-holdings" className="u-paddingBottom12gu">
          <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom4gu">
            <div className="Content u-sizeFit u-sm-marginBottom3gu u-sm-sizeFull u-paddingTop0">
              <h3 className="u-marginVert0">
                Top Holdings (% of Net Assets){' '}
                <span className="u-sm-block u-sm-paddingTop1gu">
                  as of {formatDateStandard(etfHoldingAsOfDate)}
                </span>
              </h3>
            </div>

            <div className="u-sizeFit u-sm-sizeFull Disclaimer-text">
              <p>
                <a className="u-sm-hidden" href={downloadFullHoldings}>
                  Download all holdings (.csv)
                </a>
              </p>
            </div>
          </div>

          <div className="u-overflowX u-marginBottom4gu">
            <table className="Table Table--reversed Table--striped">
              <thead className="Table-head">
                <tr className="Table-row">
                  <th className="Table-header">Description</th>
                  <th className="Table-header u-textRight">Ticker</th>
                  <th className="Table-header u-textRight">Asset Type</th>
                  <th className="Table-header Table-tooltip-header u-textRight u-posRelative">
                    <Tooltip
                      heading={
                        getTooltipContentByKey(
                          etfTooltipData,
                          'Holdings Quantity'
                        )?.heading || 'Quantity'
                      }
                      content={
                        getTooltipContentByKey(
                          etfTooltipData,
                          'Holdings Quantity'
                        )?.content || ''
                      }
                      id="quantity"
                      direction="Tooltip-right"
                    >
                      <span className="u-textSecondary Tooltip-label">
                        Quantity
                      </span>
                      <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                        info
                      </span>
                    </Tooltip>
                  </th>
                  <th className="Table-header u-textRight">Weight (%)</th>
                  <th className="Table-header u-textRight">Market Value</th>
                  <th className="Table-header u-textRight">Notional</th>
                </tr>
              </thead>
              <tbody className="Table-body">
                {this.renderTopHoldingsTable()}
                <tr className="Table-row" key={'view-all-holdings-link'}>
                  <td className="Table-cell" colSpan="5">
                    <a className="js-full-holdings-link" href="#">
                      View all holdings
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            className="Disclaimer"
            data-qa-automation="top-holdings-disclosure"
          >
            <div
              className="Disclaimer-text"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(this.state.disclosure),
              }}
            />
            <div className="Disclaimer-text">
              {nsccFileUrl && (
                <p>
                  <a href={nsccFileUrl}>Download NSCC file (.xlsx)</a>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
PortfolioTopHoldingsETF.propTypes = {
  etfHoldingDetail: PropTypes.object,
}

export default PortfolioTopHoldingsETF
